
    import {
        Component,
        Prop,
        Emit,
        Model,
    } from 'vue-property-decorator';

    import CheckBoxInputCommon from './common/CheckBoxInputCommon.vue';

    @Component
    export default class CheckBoxInput extends CheckBoxInputCommon {
        @Model('change') readonly modelValue!: (string | number)[];

        @Prop() readonly label!: string;

        @Prop() readonly disabled!: boolean;

        @Prop({ default: true }) readonly hideOverflowText!: boolean;

        @Prop() readonly value!: string | number;

        @Prop() readonly checkBoxSize!: string;

        @Prop({ default: false }) readonly loading?: boolean;

        @Emit('change')
        updateInput({ target }: { target: HTMLInputElement }): (string | number)[] {
            if (this.loading) {
                return this.modelValue;
            }

            const newValue = [...this.modelValue];

            if (target.checked) {
                newValue.push(this.value);
            } else {
                newValue.splice(newValue.indexOf(this.value), 1);
            }

            return newValue;
        }

        get isChecked(): boolean {
            return !!~this.modelValue.indexOf(this.value);
        }
    }

